import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { RelationshipType } from '../../Constants/Enums/Customer/RelationshipType';

declare var IS_RUNNING_IN_APP_POOL;

export class RelationshipClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public delete(primaryActorId: number, secondaryActorId: number, relationshipTypes: Array<RelationshipType>): Promise<Array<RelationshipType>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/Relationship/Delete';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { primaryActorId: primaryActorId, secondaryActorId: secondaryActorId, relationshipTypes: relationshipTypes }

    return AjaxWrapper.delete<Array<RelationshipType>, any>(url, data);
  }
  public post(primaryActorId: number, secondaryActorId: number, originRelationships: Array<RelationshipType>, newRelationships: Array<RelationshipType>): Promise<Array<RelationshipType>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/Relationship/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { primaryActorId: primaryActorId, secondaryActorId: secondaryActorId, originRelationships: originRelationships, newRelationships: newRelationships }

    return AjaxWrapper.post<Array<RelationshipType>, any>(url, data);
  }
}

